import * as React from 'react';
import UserLookup from '../../common/form-controls/Lookups/UserLookup';
import FieldHandler from '../../../models/interfaces/FieldHandler';
import Urls from '../../../utils/Urls';

interface CustodianTwoInputProps extends FieldHandler<string> {}

interface CustodianTwoInputState {}

export class CustodianTwoInput extends React.Component<CustodianTwoInputProps, CustodianTwoInputState> {
	render() {
		return (
			<UserLookup
				id="custodian-two-lookup"
				label="Custodian Two"
				isSubscriptionOwner
				noteLink={Urls.CloudLearningPaths}
				note={
					!this.props.hideNotes &&
					'Custodians are responsible for executing the above actions on behalf of the subscription owner. Limited to Approved Subscription Owners. '
				}
				{...this.props}
			/>
		);
	}
}
